import { createFileRoute } from "@tanstack/react-router";
import LinkedPeoplePage from "@/site/pages/linked-people";

// Linked people (PRD 16 §6.4): everyone who gets the member's birthday — their lists and their
// one-to-one links — requests waiting on them, and what else they share. Members only, full
// session (D4).
export const Route = createFileRoute("/linked/")({
  component: LinkedPeoplePage,
});
